import React, { useMemo } from 'react';

import { usePageContent } from '~/App/shared/hooks/use-page-content';

import { Collection } from './Collection';
import { loadData } from './Collection.LoadData';

const View = (props: unknown) => {
  const pageContent = usePageContent();
  const children = useMemo(
    () =>
      pageContent ? (
        <Collection key={pageContent.data.slug} {...pageContent} {...props} />
      ) : null,
    [pageContent, props]
  );

  return children;
};

View.loadData = loadData;

export default View;
